module.exports = __webpack_public_path__ + "img/53.00c8b027.jpg";